import type { Step } from "react-joyride";

export const productFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ/ແກ້ໄຂສິນຄ້າ. ຕື່ມຊື່ 3 ພາສາ (ລາວ, ไทย, EN), slug, ລາຍລະອຽດ, options, ໝວດໝູ່, tags ແລະ ສະຖານະ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="product-form-tabs"]',
    content: "ເລືອກພາສາທີ່ຕ້ອງການປ້ອນຊື່ ແລະ ລາຍລະອຽດ: ລາວ, ไทย  ຫຼື English.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="product-form-name-lo"]',
    content: "ຊື່ສິນຄ້າພາສາລາວ — ບັງຄັບ. ນີ້ແມ່ນຊື່ຫຼັກທີ່ຈະສະແດງໃນລະບົບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="product-form-slug"]',
    content: "Slug ຈະຖືກສ້າງອັດຕະໂນມັດຈາກຊື່ອັງກິດ ຫຼື ຊື່ລາວ. ທ່ານສາມາດແກ້ໄຂໄດ້ຖ້າຕ້ອງການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="product-form-description"]',
    content: "ປ້ອນລາຍລະອຽດສິນຄ້າເປັນ 3 ພາສາ. ອະທິບາຍຄຸນນະພາບ, ຂະໜາດ, ສີ ຫຼື ຂໍ້ມູນອື່ນໆ.",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-options"]',
    content:
      "ເພີ່ມ options ທີ່ລູກຄ້າສາມາດເລືອກໄດ້ (ສີ, ຂະໜາດ, ສາຍຜ້າ ແລະ ອື່ນໆ). ເລືອກ options ແລ້ວ ເພີ່ມ values ທີ່ມີ.",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-category"]',
    content: "ເລືອກໝວດ (Category) ຫຼັງບ້ານສຳລັບສິນຄ້າ.",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-collections"]',
    content:
      "ເລືອກ collections ເພື່ອຈັດກຸ່ມສິນຄ້າທີ່ກ່ຽວຂ້ອງກັນ (ເຊັ່ນ: ໃໝ່, ລະເບິ່ງການ, ສ່ວຍໂປຣໂມຊັນ).",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-tags"]',
    content: "ເພີ່ມ tags ເພື່ອຄົ້ນຫາແລະ ຈັດລຽງສິນຄ້າງ່າຍຂຶ້ນ. ພິມ Enter ຫຼັງຈາກປ້ອນແຕ່ລະ tag.",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-status"]',
    content:
      "ເລືອກສະຖານະສິນຄ້າ: Draft (ບັນທຶກ), Active (ເຜີຍແຜ່), ຫຼື Archived (ເກັບຖາວ).",
    placement: "top",
  },
  {
    target: '[data-tourid="product-form-submit"]',
    content: "ກົດ 'Save Product' ເພື່ອບັນທຶກ ຫຼື 'Cancel' ເພື່ອຍົກເລີກ.",
    placement: "top",
  },
];
